module.exports = __webpack_public_path__ + "static/media/access_denied.60963e59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/access_denied.svg
// module id = 2021
// module chunks = 0